export const ComplaintWarningTypeStatus = Object.freeze({
  Verbal: 0,
  Written: 1,
  FinalWritten: 2,
});

export const ComplaintWarningTypeLabel = Object.freeze({
  [ComplaintWarningTypeStatus.Verbal]: "Verbal",
  [ComplaintWarningTypeStatus.Written]: "Written",
  [ComplaintWarningTypeStatus.FinalWritten]: "FinalWritten",
});
